import { getQuoteConstraints, QuoteConstraint, type Quote } from '../../../../modules/quotes'
import { type QuotesViewHandler } from '../quotesView.types'
import * as sortQuotes from '../sort.utils'

const sort = (quotes: Quote[]) => {
  quotes = sortQuotes.byCheapestPrice(quotes)
  quotes = sortQuotes.byConstraints(quotes, (quote: Quote) => getConstraints(quote, true))
  return quotes
}

/**
 * ignore date and time related constraints when sorting by best flexible price
 */
const getConstraints = (quote: Quote, sorting = false) => {
  const constraints = getQuoteConstraints(quote)
  if (!constraints) {
    return []
  }
  const ignoreConstraints = sorting
    ? [
        QuoteConstraint.unavailableDate,
        QuoteConstraint.unavailablePreferredTime,
      ]
    : []

  return constraints.filter(constraint => !ignoreConstraints.includes(constraint))
}

const viewHandler: QuotesViewHandler = {
  sort,
  getConstraints,
}

export default viewHandler
